interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
}

/**
 * Mali inline trend graf (linija + svjetla pozadina).
 * Idealan za prikaz "kretanja" pored velike brojke u headeru kartice.
 */
const Sparkline: React.FC<SparklineProps> = ({
  values,
  width = 80,
  height = 24,
  stroke = "#10b981",
  fill = "rgba(16, 185, 129, 0.15)",
}) => {
  if (values.length < 2) {
    return <svg width={width} height={height} />;
  }

  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  const padY = 2;

  const toPoint = (v: number, i: number) => {
    const x = (i / (values.length - 1)) * width;
    const y = padY + (1 - (v - min) / range) * (height - 2 * padY);
    return { x, y };
  };

  const points = values.map((v, i) => toPoint(v, i));
  const linePath = points
    .map((p, i) => (i === 0 ? `M ${p.x} ${p.y}` : `L ${p.x} ${p.y}`))
    .join(" ");
  const areaPath = `${linePath} L ${width} ${height} L 0 ${height} Z`;

  return (
    <svg width={width} height={height} className="block">
      <path d={areaPath} fill={fill} />
      <path d={linePath} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default Sparkline;
